import React, { PropTypes } from 'react';

import data from './data';
import Masonry from '../Masonry';

import { description, fullWidth } from './styles.module.css';
import { srOnly } from '../../base-styles/mixins.module.css';

const Discover = ({ showLess, location, countryCode }) => (
  <div className={fullWidth}>
    <h1 className={description}>Find your next race{countryCode === 'US' && (<span className={srOnly}> in the USA</span>)}</h1>
    <span className={srOnly}> Find half marathons, 5ks, 10ks and Triathlons{countryCode === 'US' && ('in the USA')} and around the world in 2018, 2019 and beyond, with race calendars, runner reviews, course maps, registration, results and more.</span>
    <Masonry
      collections={data}
      showLess={showLess}
      location={location}
      countryCode={countryCode}
    />
  </div>
);

Discover.propTypes = {
  /*
   * Boolean to determine whether to show first four events plus discover button.
   */
  showLess: PropTypes.bool,
  /*
   *  An object containing the location of the slug
   */
  location: PropTypes.shape({
    name: PropTypes.string,
    slug: PropTypes.string,
  }),
  countryCode: PropTypes.string,
};

Discover.defaultProps = {
  showLess: false,
  location: undefined,
  countryCode: undefined,
};

export default Discover;



// WEBPACK FOOTER //
// ./app/src/components/Discover/index.jsx